export default "https://cdn-static.gokick.com/assets/ac567471f1b9fb2f6cedfba22f3391469dbaa38e/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";